import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { InstitutionsService } from './shared/services/institutions.service';
import { ClientsService } from './shared/model/aSupprimer/client.service';
import { SaveService } from './shared/services/save.service';
import { ConfigService } from './shared/services/config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  client$: FirebaseObjectObservable<any>;
  institutions$: FirebaseListObservable<any[]>;

  constructor(
    private afAuth: AngularFireAuth,
    private af: AngularFireDatabase,
    private iservice: InstitutionsService,
    private cservice: ClientsService,
    private saveService: SaveService,
    private configService: ConfigService,
    private router: Router) {
  }

  ngOnInit() {
    this.saveService.clearAll();
    this.configService.findConfigs().subscribe((res) => {
      this.saveService.setConfig(res)
      this.router.navigate(['accueil']);
    });
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/app.component.ts